export default function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.5C0 9.4543 8.9543 0.5 20 0.5C31.0457 0.5 40 9.4543 40 20.5C40 31.5457 31.0457 40.5 20 40.5C8.9543 40.5 0 31.5457 0 20.5ZM19 14.5C16.2386 14.5 14 16.7386 14 19.5C14 22.2614 16.2386 24.5 19 24.5C20.3813 24.5 21.6285 23.9425 22.5355 23.0355C23.4425 22.1285 24 20.8813 24 19.5C24 16.7386 21.7614 14.5 19 14.5ZM10 19.5C10 14.5294 14.0294 10.5 19 10.5C23.9706 10.5 28 14.5294 28 19.5C28 21.2602 27.4934 22.904 26.6196 24.2912L29.4142 27.0858C30.1953 27.8668 30.1953 29.1332 29.4142 29.9142C28.6332 30.6953 27.3668 30.6953 26.5858 29.9142L23.7912 27.1196C22.404 27.9934 20.7602 28.5 19 28.5C14.0294 28.5 10 24.4706 10 19.5Z"
        fill="url(#paint0_linear_3710_13938)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3710_13938"
          x1="0"
          y1="0.5"
          x2="40"
          y2="40.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0068FF" />
          <stop offset="1" stopColor="#0068FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
